import React from "react";
import { fabric } from "fabric";
import UtilsCanvas from "../utils/UtilsCanvas";
import GlobalEvents from "../event/GlobalEvents";

//icons
import { Delete } from "@material-ui/icons";
import InvertColorsIcon from '@material-ui/icons/InvertColors';
import FormatColorResetIcon from '@material-ui/icons/FormatColorReset';
import WbSunnyIcon from '@material-ui/icons/WbSunny'; //saturation
import SettingsBrightnessIcon from '@material-ui/icons/SettingsBrightness'; 
import AcUnitIcon from '@material-ui/icons/AcUnit'; //gama
import TonalityIcon from '@material-ui/icons/Tonality'; //grayscale
import TrackChangesIcon from '@material-ui/icons/TrackChanges'; //sharpen
import BlurOnIcon from '@material-ui/icons/BlurOn';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import FilterIcon from '@material-ui/icons/Filter';
import FilterNoneIcon from '@material-ui/icons/FilterNone';

// HTML5 Canvas Filters
// https://www.html5rocks.com/en/tutorials/canvas/imagefilters/

const effects = [
  // { label: 'Clear all',     type: "Clear",        unique: true,  expanded: false },
  { label: 'Blend Color',   type: "BlendColor",   unique: true,  expanded: true, },
  { label: 'Blend Image',   type: "BlendImage",   unique: true,  expanded: true, },
  { label: 'Blur',          type: "Blur",         unique: true,  expanded: true, },
  { label: 'Brightness',    type: "Brightness",   unique: true,  expanded: true, },
  { label: 'Contrast',      type: "Contrast",     unique: true,  expanded: true, },
  { label: 'Convolute',     type: "Convolute",    unique: true,  expanded: true, },
  // { label: 'Duotone',       type: "Duotone",      unique: true,  expanded: true, },
  { label: 'Gamma',         type: "Gamma",        unique: true,  expanded: true, },
  { label: 'Grayscale',     type: "Grayscale",    unique: true,  expanded: true, },
  { label: 'Invert',        type: "Invert",       unique: true,  expanded: true, },
  { label: 'Noise',         type: "Noise",        unique: true,  expanded: true, },
  { label: 'Remove Color',  type: "RemoveColor",  unique: false, expanded: true, },
  { label: 'Saturation',    type: "Saturation",   unique: true,  expanded: true, },
  // { label: 'Sharpen',       type: "Sharpen",      unique: true,  expanded: true, },
];

export default class Effects extends React.Component {
  
  // ---------------------------------------------------------------------------
  // list filters
  // https://material-ui.com/components/material-icons/
  // ---------------------------------------------------------------------------
  getFilters = () => {
    return effects;
  }

  // ---------------------------------------------------------------------------
  // get icon by name
  // https://material-ui.com/components/material-icons/
  // ---------------------------------------------------------------------------
  getIcon = ( type  ) => {
    switch( type ){
      case 'Clear':       return <Delete fontSize="small"/>;
      case 'Invert':      return <SwapHorizIcon fontSize="small"/>;
      case 'Grayscale':   return <TonalityIcon fontSize="small"/>;
      case 'Brightness':  return <SettingsBrightnessIcon fontSize="small"/>;
      case 'Gamma':       return <AcUnitIcon fontSize="small"/>;
      case 'Contrast':    return <InvertColorsIcon fontSize="small"/>;
      case 'Saturation':  return <WbSunnyIcon fontSize="small"/>;
      case 'Noise':       return <EqualizerIcon fontSize="small"/>;
      case 'Blur':        return <BlurOnIcon fontSize="small"/>;
      case 'Sharpen':     return <EqualizerIcon fontSize="small"/>;
      case 'Convolute':   return <TrackChangesIcon fontSize="small"/>;
      case 'BlendColor':  return <FilterNoneIcon fontSize="small"/>;
      case 'BlendImage':  return <FilterIcon fontSize="small"/>;
      case 'RemoveColor': return <FormatColorResetIcon fontSize="small"/>;
      case 'Duotone':     return null;
      default: console.log('NoIcon');
    }
  };

  // ---------------------------------------------------------------------------
  // add filter
  // ---------------------------------------------------------------------------
  add = ( c, type, el, callback  ) => {

    console.log( 'Add Filter: ', type );
    el = el || effects.find( (element) => element.type === type );

    switch( type ){
      case 'Clear':       this.Clear( c );               break;
      case 'Invert':      this.Invert( c, -1, el );      break;
      case 'Grayscale':   this.Grayscale( c, -1, el );   break;
      case 'Brightness':  this.Brightness( c, -1, el );  break;
      case 'Gamma':       this.Gamma( c, -1, el );       break;
      case 'Contrast':    this.Contrast( c, -1, el );    break;
      case 'Saturation':  this.Saturation( c, -1, el );  break;
      case 'Noise':       this.Noise( c, -1, el );       break;
      case 'Blur':        this.Blur( c, -1, el );        break;
      case 'Sharpen':     this.Sharpen( c, -1, el );     break;
      case 'Convolute':   this.Emboss( c, -1, el );      break;
      case 'BlendColor':  this.BlendColor( c, -1, el );  break;
      case 'BlendImage':  this.BlendImage( c, -1, el );  break;
      case 'RemoveColor': this.RemoveColor( c, -1, el ); break;
      case 'Duotone':     this.Duotone( c, -1, el );     break;
      default: console.log('');
    }

    if(callback !== undefined){
      callback();
    }

  };

  // ---------------------------------------------------------------------------
  // apply filter filter by index
  // ---------------------------------------------------------------------------
  apply = ( c, index, filter, callback ) => {

    if(typeof filter !== 'object') return;

    // get active object
    let object = c.getActiveObject();
    if (object === undefined || object === null) return;
    //if (object.typeName !== 'Image') return;

    // se filters não existir, criar uma array
    object.filters = object.filters || [];
 
    // console.log( 'filter:', filter );
    // console.log( 'filters:', object.filters );
    
    // verifica se o index é verdadeiro e maior que -1
    if( Number.isInteger(index) && !isNaN(index) && Number(index) >= 0 ){
      
      // então atualiza o filtro por ele mesmo, ou uma nova configuração do mesmo filtro
      object.filters[index] = filter;
  
    // se o index for -1 ou NaN (Not a Number)
    } else { 

      // ao contrário disso procura o mesmo filtro pelo nome
      let indexUnique = object.filters.findIndex( (arr) => arr.type === filter.type );      
      // verifica se é um filtro classificado como único 
      // verifica se não existe outro com o mesmo nome
      if( filter.unique === true && indexUnique === -1){
          object.filters.push(filter);
      }
      // verifica se está classificado para não ser único 
      // pode ter um ou mais filtros de igual nome
      else if( filter.unique === false){
        object.filters.push(filter);
      }

    }

    // inverte para quando remover os efeitos duplicados, deixar os últimos aplicados
    // let arr = [ ...object.filters, filter ].reverse();
    // remover duplicidade de efeitos
    // arr = UtilsArray.unique(arr,['type']);
    // ------------------------------------------------------------
    // inverter novamente a ordem de efeitos
    // object.filters = arr.reverse();
    
    // apply filters
    //if(typeof object['applyFilters'] === 'function'){
    try{
      object.applyFilters();
    } catch (error) {
      console.log('ERROR(0)',error);
    }
    try {
      object.applyFilters(object.filters);
    } catch (error) {
      console.log('ERROR(1)',error);
    }
    // try {
    //   object.applyFilters(c.renderAll.bind(c));
    // } catch (error) {
    //   console.log('ERROR(2)',error);
    // }

    // Optionally you can pass a filters array to applyFilter
    // if you want to apply something that is not the image filter chain.
    //}
    
    // http://fabricjs.com/v2-breaking-changes
    // render all
    //c.renderAll();
    c.requestRenderAll(); // or the old canvas.renderAll(); if you prefer or need it
    GlobalEvents.dispatch('changeActiveObject',{ canvas:c, activeObject:object, key:object.key });
    //object.applyFilters(c.renderAll.bind(c));
    c.history.register();
  }

  // ---------------------------------------------------------------------------
  // remove by index
  // ---------------------------------------------------------------------------
  removeByIndex( c, index, callback ) {
    const object = UtilsCanvas.getActiveObject( c );
    if(object!== undefined){

      //object.filters.splice(index,1);
      object.filters = object.filters.filter((v, idx) => {
        return idx !== index;
      });
      // apply filters
      if(object && object.hasOwnProperty('filters') && typeof object['applyFilters'] === 'function'){
        try {
          object.applyFilters();          
        } catch (error) {}
      }
      // render all
      UtilsCanvas.renderAll( c );

      if(callback !== undefined){
        callback();
      }
    }
  }

  // ---------------------------------------------------------------------------
  // remove by name
  // ---------------------------------------------------------------------------
  removeByType( c, type, callback ) {
    const object = UtilsCanvas.getActiveObject( c );
    if(object!== undefined){

      object.filters = object.filters.filter((v) => {
        return v.type !== type;
      });
      // apply filters
      if(typeof object['applyFilters'] === 'function'){
        object.applyFilters();        
      }
      // render all
      UtilsCanvas.renderAll( c );

      if(callback !== undefined)
        callback();
    }
  }

  // -----------------------------------------------------------------------------
  // Filters
  // -----------------------------------------------------------------------------

  // remove all effects|filters
  Clear( c ) {    
    // get active object
    let object = UtilsCanvas.getActiveObject( c );
    if (object === undefined) return;
    // remove all filters
    object.filters = [];
    // apply filters
    if(typeof object['applyFilters'] === 'function'){
      object.applyFilters();        
    }
  // render all
    UtilsCanvas.renderAll( c );
    //object.applyFilters(c.renderAll.bind(c));
  }

  Shadow = ( c, index, settings ) => {
  }
  // const shadow = new fabric.Shadow({
  //   color: "rgba(0, 0, 0, 0.5)",
  //   blur: 10,
  // })
  
  // container.set("shadow", shadow)
  // obj.set("shadow", shadow)

  // 
  Invert = ( c, index, settings ) => {
    const { type, label, unique, expanded, icon } = settings;
    let filter = new fabric.Image.filters.Invert();
    filter.type = type;
    filter.label = label;
    filter.unique = unique;
    filter.expanded = expanded;
    filter.icon = icon;
    this.apply( c, index, filter );
  }

  // mode: between 'average', 'lightness', 'luminosity' 
  Grayscale = ( c, index, settings ) => {
    const { type, label, unique, expanded, icon } = settings;
    let filter = new fabric.Image.filters.Grayscale({
      // ---------------------------------------------------- 
      mode: 'average', // 'average', 'lightness', 'luminosity' 
      // ---------------------------------------------------- 
      ...settings,
    });
    filter.type = type;
    filter.label = label;
    filter.unique = unique;
    filter.expanded = expanded;
    filter.icon = icon;
    console.log('>>>>>>',filter);
    this.apply( c, index, filter );
  }

  // distance: 0|1
  // color: rgb|hex
  RemoveColor( c, index, settings ) {
    const { type, label, unique, expanded, icon } = settings;
    let filter = new fabric.Image.filters.RemoveColor({
      // ---------------------------------------------------- 
      color: '#1210ED',
      distance: 0.2,
      threshold: 0.2,
      // ---------------------------------------------------- 
      ...settings, 
    });
    filter.type = type;
    filter.label = label;
    filter.unique = unique;
    filter.expanded = expanded;
    filter.icon = icon;
    this.apply( c, index, filter );
  }

  // Gamma array value, from 0.01 to 2.2.
  // Default Value: [1,1,1]
  // Sample: [1, 0.5, 2.1]
  Gamma( c, index, settings ) {
    const { type, label, unique, expanded, icon } = settings;
    let filter = new fabric.Image.filters.Gamma({
      // ---------------------------------------------------- 
      gamma: [ 1, 1, 1 ], // red, green, blue
      // ---------------------------------------------------- 
      ...settings, 
    });
    filter.type = type;
    filter.label = label;
    filter.unique = unique;
    filter.expanded = expanded;
    filter.icon = icon;
    this.apply( c, index, filter );
  }

  // contrast: 0|1
  Contrast( c, index, settings ) {
    const { type, label, unique, expanded, icon } = settings;
    let filter = new fabric.Image.filters.Contrast({
      // ---------------------------------------------------- 
      contrast: 0.25, // 0 to 1.
      // ---------------------------------------------------- 
      ...settings, 
    });
    filter.type = type;
    filter.label = label;
    filter.unique = unique;
    filter.expanded = expanded;
    filter.icon = icon;
    this.apply( c, index, filter );
  }

  // saturation: 0|1
  Saturation( c, index, settings ) {
    const { type, label, unique, expanded, icon } = settings;
    let filter = new fabric.Image.filters.Saturation({
      // ---------------------------------------------------- 
      saturation: 0, // -1 to 1.
      // ---------------------------------------------------- 
      ...settings, 
    });
    filter.type = type;
    filter.label = label;
    filter.unique = unique;
    filter.expanded = expanded;
    filter.icon = icon;
    this.apply( c, index, filter );
  }

  // noise: 250 // 0 - 500
  Noise( c, index, settings ) {
    const { type, label, unique, expanded, icon } = settings;
    let filter = new fabric.Image.filters.Noise({
      // ---------------------------------------------------- 
      noise: 100, // 0 - 500
      // ---------------------------------------------------- 
      ...settings, 
    });
    filter.type = type;
    filter.label = label;
    filter.unique = unique;
    filter.expanded = expanded;
    filter.icon = icon;
    this.apply( c, index, filter );
  }

  // var filter = new fabric.Image.filters.Convolute({
  //   matrix: [ 1/9, 1/9, 1/9,
  //             1/9, 1/9, 1/9,
  //             1/9, 1/9, 1/9 ]
  // });

  // blur: 0.5 // 0 - 1
  Blur( c, index, settings ) {
    const { type, label, unique, expanded, icon } = settings;
    let filter = new fabric.Image.filters.Blur({
      // ---------------------------------------------------- 
      blur: 0.1, // 0 - 1
      // ---------------------------------------------------- 
      ...settings, 
    });
    filter.type = type;
    filter.label = label;
    filter.unique = unique;
    filter.expanded = expanded;
    filter.icon = icon;
    this.apply( c, index, filter );
  }

  // matrix: 
  // [  0, -1,  0,
  //   -1,  5, -1,
  //    0, -1,  0 ]
  Sharpen( c, index, settings ) {
    const { type, label, unique, expanded, icon } = settings;
    let filter = new fabric.Image.filters.Convolute({
      // ---------------------------------------------------- 
      matrix: 
      [ 0,-1 ,0,
       -1, 5,-1,
        0,-1, 0,],
      // ---------------------------------------------------- 
      ...settings, 
    });
    filter.type = type;
    filter.label = label;
    filter.unique = unique;
    filter.expanded = expanded;
    filter.icon = icon;
    this.apply( c, index, filter );
  }

  // matrix: 
  // [ 1,   1,  1,
  //   1, 0.7, -1,
  //  -1,  -1, -1 ]
  Emboss( c, index, settings ) {
    const { type, label, unique, expanded, icon } = settings;
    let filter = new fabric.Image.filters.Convolute({
      // ---------------------------------------------------- 
      matrix: [0,-1,0,-1,5,-1,0,-1,0],
      // [ 1,   1,  1,
      //   1, 0.7, -1,
      //  -1,  -1, -1 ],
       //opaque: false,
      // ---------------------------------------------------- 
      ...settings, 
    });
    filter.type = type;
    filter.label = label;
    filter.unique = unique;
    filter.expanded = expanded;
    filter.icon = icon;
    this.apply( c, index, filter );
  }

  Brightness( c, index, settings ) {
    const { type, label, unique, expanded, icon } = settings;
    let filter = new fabric.Image.filters.Brightness({
      // ---------------------------------------------------- 
      brightness: 0, //-1 to 1.
      // ---------------------------------------------------- 
      ...settings, 
    });
    filter.type = type;
    filter.label = label;
    filter.unique = unique;
    filter.expanded = expanded;
    filter.icon = icon;
    this.apply( c, index, filter );
  }

  // <select>
  //   <option value="add" selected>Add</option>
  //   <option value="diff">Diff</option>
  //   <option value="subtract">Subtract</option>
  //   <option value="multiply">Multiply</option>
  //   <option value="screen">Screen</option>
  //   <option value="lighten">Lighten</option>
  //   <option value="darken">Darken</option>
  //   <option value="overlay">Overlay</option>
  //   <option value="exclusion">Exclusion</option>
  //   <option value="tint">Tint</option>
  // </select>

  //  var filter = new fabric.Image.filters.BlendImage({
  //   image: fabricImageObject,
  //   mode: 'multiply',
  //   alpha: 0.5
  //  });

  BlendColor( c, index, settings ) {
    const { type, label, unique, expanded, icon } = settings;
    let filter = new fabric.Image.filters.BlendColor({
      // ---------------------------------------------------- 
      color: '#99D843', // hex
      mode: 'multiply', // add, diff, subtract, multiply, screen, lighten, darken, overlay, exclusion, tint       
      alpha: 0.5, // 0 - 1 
      // ---------------------------------------------------- 
      ...settings, 
    });
    filter.type = type;
    filter.label = label;
    filter.unique = unique;
    filter.expanded = expanded;
    filter.icon = icon;
    this.apply( c, index, filter );
  }

  BlendImage( c, index, settings ) {
    const { type, label, unique, expanded, icon } = settings;
    let filter = new fabric.Image.filters.BlendImage({
      // ---------------------------------------------------- 
      image: null,
      color: '#99D843', // hex
      mode: 'multiply', // add, diff, subtract, multiply, screen, lighten, darken, overlay, exclusion, tint       
      alpha: 0.5, // 0 - 1 
      // ---------------------------------------------------- 
      ...settings, 
    });
    filter.type = type;
    filter.label = label;
    filter.unique = unique;
    filter.expanded = expanded;
    filter.icon = icon;
    this.apply( c, index, filter );
  }

  // Matrix Samples: 
  //  https://kazzkiq.github.io/svg-color-filter/
  Matrix( c, index, settings ) {
    const { type, label, unique, expanded, icon } = settings;
    let filter = new fabric.Image.filters.ColorMatrix({
      ...settings, 
    });
    filter.type = type;
    filter.label = label;
    filter.unique = unique;
    filter.expanded = expanded;
    filter.icon = icon;
    this.apply( c, index, filter );
  }

    /*

    ideia pra complementar
    https://mdbootstrap.com/previews/docs/latest/html/fsscroller/basic.html#view-1

    efeitos

    http://fabricjs.com/text-on-paths
    http://fabricjs.com/duotone-filter
    https://codepen.io/durga598/pen/gXQjdw
    https://stackoverflow.com/questions/48761416/how-to-add-polygon-points-and-draw-it-on-an-image-in-fabric-js
    http://jsfiddle.net/77vg88mc/34/
    http://fabricjs.com/custom-controls-polygon
    http://fabricjs.com/quadratic-curve

    Invert
    Grayscale
    Remove color
    Brightness
    Gamma
    Contrast
    Saturation
    Noise
    Blur
    Sharpen
    Emboss
    Blend Color

    */

}
